module.exports = "https://health.dajiuxing.com.cn/img/assets/login/Headicon.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2Flogin%2FHeadicon.png
// module id = pV6o
// module chunks = 93